import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _inherits from "@babel/runtime/helpers/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/setPrototypeOf";
var _excluded = ["contentLink"],
  _excluded2 = ["cloudId", "issueKey", "commentId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function (e, r, t) { if ("" === t) return e; var p = o[r]; return Array.isArray(p) ? "$" + p.join("$") : "number" == typeof p ? "$" + p : ""; })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
import _mainIssueDataQuery from "./__generated__/mainIssueDataQuery.graphql";
import React, { useEffect, useMemo } from 'react';
import { di } from 'react-magnetic-di';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { Experiences } from '../../../../types';
import { triggerJiraIssueCommentLoadedAnalytics, useCreateFireAnalyticsFromTrigger } from '../../../utils/analytics';
import { useExperienceTracker } from '../../../utils/experience-tracking/adapter/context';
import { ErrorBoundarySuspense } from '../../error-boundary-suspense';
import { ReactionsPlaceholder } from '../reactions-placeholder';
import { ReactionsBar } from './reactions-bar/main';
export var JIRA_REACT_BAR_EVENTS = ['streamhub-jira-comment-mention', 'streamhub-jira-comment-create'];
var extractIssueKey = function extractIssueKey(link) {
  var _match$groups$issueKe, _match$groups;
  var issueKeyRx = /*#__PURE__*/_wrapRegExp(/^\/browse\/([a-z0-9\-]+)$/i, {
    issueKey: 1
  });
  var match = issueKeyRx.exec(new URL(link).pathname);
  return (_match$groups$issueKe = match === null || match === void 0 || (_match$groups = match.groups) === null || _match$groups === void 0 ? void 0 : _match$groups.issueKey) !== null && _match$groups$issueKe !== void 0 ? _match$groups$issueKe : undefined;
};
export var JiraReactBar = function JiraReactBar(_ref) {
  var contentLink = _ref.contentLink,
    others = _objectWithoutProperties(_ref, _excluded);
  var issueKey = extractIssueKey(contentLink);
  if (!issueKey) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ErrorBoundarySuspense, {
    subjectId: "jiraCommentNotificationReactionBar",
    loadingFallback: /*#__PURE__*/React.createElement(ReactionsPlaceholder, null),
    errorFallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(InnerJiraReactBar, _extends({
    issueKey: issueKey
  }, others)));
};
var InnerJiraReactBar = function InnerJiraReactBar(_ref2) {
  var _issueData$jira, _issueData$jira3, _issueData$jira4, _issueData$jira7, _issueData$jira8, _issueData$jira9;
  var cloudId = _ref2.cloudId,
    issueKey = _ref2.issueKey,
    commentId = _ref2.commentId,
    others = _objectWithoutProperties(_ref2, _excluded2);
  var experienceTracker = useExperienceTracker();
  useEffect(function () {
    experienceTracker.start({
      name: Experiences.FETCH_JIRA_COMMENT_DATA_IN_CONTEXT,
      id: 'fetchJiraCommentData'
    });
  }, [experienceTracker]);
  var fireJiraIssueCommentLoaded = useCreateFireAnalyticsFromTrigger(triggerJiraIssueCommentLoadedAnalytics);
  var issueData = useLazyLoadQuery(_mainIssueDataQuery, {
    issueKey: issueKey,
    commentId: commentId,
    cloudId: cloudId
  }, {
    fetchPolicy: 'store-and-network'
  });
  var issueAri = issueData === null || issueData === void 0 || (_issueData$jira = issueData.jira) === null || _issueData$jira === void 0 || (_issueData$jira = _issueData$jira.issueByKey) === null || _issueData$jira === void 0 ? void 0 : _issueData$jira.id;
  var checkResult = useMemo(function () {
    var _issueData$jira2;
    if (!issueAri) {
      return {
        result: 'fail',
        reason: 'issueNotFound'
      };
    }
    if (!((_issueData$jira2 = issueData.jira) !== null && _issueData$jira2 !== void 0 && (_issueData$jira2 = _issueData$jira2.issueByKey) !== null && _issueData$jira2 !== void 0 && (_issueData$jira2 = _issueData$jira2.comments) !== null && _issueData$jira2 !== void 0 && (_issueData$jira2 = _issueData$jira2.edges) !== null && _issueData$jira2 !== void 0 && _issueData$jira2.some(function (s) {
      var _s$node;
      return (s === null || s === void 0 || (_s$node = s.node) === null || _s$node === void 0 ? void 0 : _s$node.commentId) === commentId;
    }))) {
      return {
        result: 'fail',
        reason: 'commentNotFound'
      };
    }
    if (!issueData.jira.issueByKey.canAddComments) {
      return {
        result: 'fail',
        reason: 'noPermission'
      };
    }
    return {
      result: 'success'
    };
  }, [commentId, issueAri, issueData === null || issueData === void 0 || (_issueData$jira3 = issueData.jira) === null || _issueData$jira3 === void 0 || (_issueData$jira3 = _issueData$jira3.issueByKey) === null || _issueData$jira3 === void 0 ? void 0 : _issueData$jira3.canAddComments, issueData === null || issueData === void 0 || (_issueData$jira4 = issueData.jira) === null || _issueData$jira4 === void 0 || (_issueData$jira4 = _issueData$jira4.issueByKey) === null || _issueData$jira4 === void 0 || (_issueData$jira4 = _issueData$jira4.comments) === null || _issueData$jira4 === void 0 ? void 0 : _issueData$jira4.edges]);
  useEffect(function () {
    var _issueData$jira5, _issueData$jira6;
    fireJiraIssueCommentLoaded(_objectSpread({
      notification: others.experienceTrackingAttributes.notification,
      listIndex: others.experienceTrackingAttributes.listIndex,
      issueKey: issueKey,
      commentId: commentId,
      issueAri: issueAri,
      projectId: (_issueData$jira5 = issueData.jira) === null || _issueData$jira5 === void 0 || (_issueData$jira5 = _issueData$jira5.issueByKey) === null || _issueData$jira5 === void 0 || (_issueData$jira5 = _issueData$jira5.projectField) === null || _issueData$jira5 === void 0 || (_issueData$jira5 = _issueData$jira5.project) === null || _issueData$jira5 === void 0 ? void 0 : _issueData$jira5.projectId,
      projectType: (_issueData$jira6 = issueData.jira) === null || _issueData$jira6 === void 0 || (_issueData$jira6 = _issueData$jira6.issueByKey) === null || _issueData$jira6 === void 0 || (_issueData$jira6 = _issueData$jira6.projectField) === null || _issueData$jira6 === void 0 || (_issueData$jira6 = _issueData$jira6.project) === null || _issueData$jira6 === void 0 || (_issueData$jira6 = _issueData$jira6.projectType) === null || _issueData$jira6 === void 0 ? void 0 : _issueData$jira6.toLowerCase()
    }, checkResult));
  }, [commentId, checkResult, fireJiraIssueCommentLoaded, issueAri, (_issueData$jira7 = issueData.jira) === null || _issueData$jira7 === void 0 || (_issueData$jira7 = _issueData$jira7.issueByKey) === null || _issueData$jira7 === void 0 || (_issueData$jira7 = _issueData$jira7.projectField) === null || _issueData$jira7 === void 0 || (_issueData$jira7 = _issueData$jira7.project) === null || _issueData$jira7 === void 0 ? void 0 : _issueData$jira7.projectId, (_issueData$jira8 = issueData.jira) === null || _issueData$jira8 === void 0 || (_issueData$jira8 = _issueData$jira8.issueByKey) === null || _issueData$jira8 === void 0 || (_issueData$jira8 = _issueData$jira8.projectField) === null || _issueData$jira8 === void 0 || (_issueData$jira8 = _issueData$jira8.project) === null || _issueData$jira8 === void 0 ? void 0 : _issueData$jira8.projectType, issueKey, others.experienceTrackingAttributes.listIndex, others.experienceTrackingAttributes.notification]);
  useEffect(function () {
    if (checkResult.result === 'fail') {
      if (checkResult.reason === 'noPermission') {
        experienceTracker.fail({
          name: Experiences.FETCH_JIRA_COMMENT_DATA_IN_CONTEXT,
          attributes: {
            commentId: commentId
          },
          error: {
            name: 'Permission Error',
            message: "User does not have permission to add reaction for ".concat(commentId)
          }
        });
        return;
      }
      experienceTracker.fail({
        name: Experiences.FETCH_JIRA_COMMENT_DATA_IN_CONTEXT,
        attributes: {
          commentId: commentId
        },
        error: {
          name: 'GraphQL Error',
          message: "Failed to fetch comment data for ".concat(commentId)
        }
      });
      return;
    }
    experienceTracker.succeed({
      name: Experiences.FETCH_JIRA_COMMENT_DATA_IN_CONTEXT,
      attributes: {
        commentId: commentId
      }
    });
  }, [checkResult, commentId, experienceTracker]);
  if (checkResult.result === 'success' && issueAri && issueData !== null && issueData !== void 0 && (_issueData$jira9 = issueData.jira) !== null && _issueData$jira9 !== void 0 && _issueData$jira9.issueByKey) {
    var _issueData$jira$issue, _issueData$jira$issue2;
    var commentAri = "ari:cloud:jira:".concat(cloudId, ":comment/").concat(commentId);
    return /*#__PURE__*/React.createElement(ReactionsBar, _extends({
      projectId: (_issueData$jira$issue = issueData.jira.issueByKey.projectField) === null || _issueData$jira$issue === void 0 || (_issueData$jira$issue = _issueData$jira$issue.project) === null || _issueData$jira$issue === void 0 ? void 0 : _issueData$jira$issue.projectId,
      projectType: (_issueData$jira$issue2 = issueData.jira.issueByKey.projectField) === null || _issueData$jira$issue2 === void 0 || (_issueData$jira$issue2 = _issueData$jira$issue2.project) === null || _issueData$jira$issue2 === void 0 ? void 0 : _issueData$jira$issue2.projectType,
      issueAri: issueAri,
      commentAri: commentAri
    }, others));
  }
  return null;
};